export default  {
    addModel: 1,
    updateModel: 2,
    lookModel: 4
}